import React from "react";
import Geometry from "../../../../components/ui/Geometry/Geometry";
import HStack from "../../../../components/ui/Stack/HStack";
import {
  getLatestInstallment,
  getLoanInstallmentSummary,
  getLoanStateColor,
  shouldShowDebtAmount,
  shouldShowLoanBankInfo,
  shouldShowLoanStatus,
  shouldShowLostPaid,
  shouldShowNextInstallment,
  shouldShowPaidRound,
  shouldShowTotalInstallment,
  shouldShowTotalPaid,
  showLoanStatusMessage,
} from "../../../../utils/loan";
import { formatMoneyNumber, formatThaiDate } from "../../../../utils/util";
import styles from "./style.module.css";
import { useTranslation } from "react-i18next";

const Detail = ({ loanInfo }) => {
  const { loan_name, loan_amount, loan_state, remaining_amount } = loanInfo;
  const { t, i18n } = useTranslation('myLoanItem');
  const { paidInstallments, totalPaid, totalInterest } =
    getLoanInstallmentSummary(loanInfo);

  const nextInstallment = getLatestInstallment(loanInfo);

  return (
    <section className={styles.container}>
      <ul className={styles.list}>
        {shouldShowLoanStatus(loanInfo) && (
          <li className={styles.row}>
            <span>{t('status')}</span>
            <HStack gap={1.5}>
              <Geometry.Circle
                size={7}
                style={{ backgroundColor: getLoanStateColor(loan_state) }}
              />
              <span
                style={{ color: getLoanStateColor(loan_state) }}
                className={styles.loanNo}
              >
                {showLoanStatusMessage(loan_state)}
              </span>
            </HStack>
          </li>
        )}
        <li className={styles.row}>
          <span>{t('loanId')}</span>
          <span className={styles.loanNo}>{loan_name}</span>
        </li>
        <li className={styles.row}>
          <span>{t('limit')}</span>
          <span>{formatMoneyNumber(loan_amount)}</span>
        </li>
        {shouldShowLostPaid(loanInfo) && (
          <li className={styles.row}>
            <span>{t('debtNow')}</span>
            <span style={{ color: "#D92D20" }}>
              {formatMoneyNumber(nextInstallment?.lost_paid)}
            </span>
          </li>
        )}
        {shouldShowDebtAmount(loanInfo) && (
          <li className={styles.row}>
            <span>{t('debtLeft')}</span>
            <span>{formatMoneyNumber(remaining_amount)}</span>
          </li>
        )}
        {/* {shouldShowTotalInstallment(loanInfo) && (
          <li className={styles.row}>
            <span>
              ชำระแล้ว {paidInstallments}/{loan_term}
            </span>
          </li>
        )} */}
        {shouldShowPaidRound(loanInfo) && (
          <li className={styles.row}>
            <span>{t('paid')}</span>
            <span>
              {paidInstallments}/{loanInfo.installments?.length || loanInfo.loan_term}
            </span>
          </li>
        )}
        {shouldShowLoanBankInfo(loanInfo) && (
          <>
            <li className={styles.row}>
              <span>{t('bankId')}</span>
              <span>{loanInfo.bank_accounts.bank_account ?? "-"}</span>
            </li>
            <li className={styles.row}>
              <span>{t('bank')}</span>
              <span>{loanInfo.bank_accounts.bank_name ?? "-"}</span>
            </li>
          </>
        )}
        {shouldShowTotalPaid(loanInfo) && (
          <li className={styles.row}>
            <span>{t('paid')}</span>
            <span>
              <span>
                {formatMoneyNumber(totalPaid)} (
                {formatMoneyNumber(totalInterest)})
              </span>
            </span>
          </li>
        )}
      </ul>

      {nextInstallment && shouldShowNextInstallment(loanInfo) && (
        <ul className={styles.list}>
          <li className={styles.row}>
            <span>{t('nextDueDate')}</span>
            <span style={{ color: "#D38D03" }}>
              {formatThaiDate(
                new Date(nextInstallment?.installment_date).toISOString()
              )}
            </span>
          </li>
          <li className={styles.row}>
            <span>{t('nextPaidLoan')}</span>
            <span style={{ color: "#D38D03" }}>
              {formatMoneyNumber(nextInstallment.total_amount)}
            </span>
          </li>
        </ul>
      )}
    </section>
  );
};

export default Detail;
